// src/services/authStorage.ts
const BASIC_AUTH_KEY = "wp_basic_auth";

export function setBasicAuth(value: string) {
  localStorage.setItem(BASIC_AUTH_KEY, value);
}

export function getBasicAuth(): string | null {
  return localStorage.getItem(BASIC_AUTH_KEY);
}

export function clearBasicAuth() {
  localStorage.removeItem(BASIC_AUTH_KEY);
}